import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Observable } from 'rxjs';

import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { Payment, PaymentFilters } from '../../../commons/models/payment.model';

export type PaymentsColumn = "code" | "description" | "start" | "lead" | "actions";

@Component({
  selector: 'payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss'],
})
export class PaymentListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  payments: Observable<Payment[]>;

  @Input()
  defaultFilters: PaymentFilters;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: Payment | null;

  @Input()
  total: Observable<number>;
  @Input()
  displayedColumns: PaymentsColumn[] = ["code", "description", "start", "lead", "actions"];

  @Input()
  canAdd: boolean;
  @Input()
  canEdit: boolean;
  @Input()
  canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<PaymentFilters> = new EventEmitter<PaymentFilters>();

  @Output()
  onSelectPayment: EventEmitter<Payment> = new EventEmitter<Payment>();
  @Output()
  onAddPayment: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditPayment: EventEmitter<Payment> = new EventEmitter<Payment>();

  constructor() { }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort) => {
      this.onSortChange.emit(sort);
    });
    this.paginator.page.subscribe((pageEvent) => {
      this.onPageChange.emit(pageEvent);
    });
  }

  addPayment() {
    this.onAddPayment.emit();
  }

  editPayment(account: Payment) {
    this.onEditPayment.emit(account);
  }

  selectPayment(account: Payment) {
    this.onSelectPayment.emit(account);
  }

  onFilter(filters: PaymentFilters) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
  }
}
